import styled from 'styled-components';

export const WrapperDate = styled.div`
  margin-top: 72px;
  left: 15%;
  font-style: italic;
  font-size: 1.11rem;
  color: #64728c;

  @media (max-width: 1567px) {
    position: initial;
    margin-right: 56%;
    margin-bottom: 40%;
  }
`;
